import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactGA from 'react-ga';
import { Link } from 'react-router-dom';
import { Helmet } from "react-helmet";
import { Row, Col, Typography, Card, Skeleton, Image, Space, Pagination, Empty, Button, Modal } from 'antd'
import { menuApplications, unmountMenuApplications, listApplications, unmountListApplications, detailDeparture, unmountDeparture } from '../../../../redux/actions/applications/applicationsAction'
import { listNotification, countNotification } from '../../../../redux/actions/header/headerAction'
import { SafetyOutlined, EnvironmentOutlined } from '@ant-design/icons'
import EmptyLogo from '../../../../assets/img/EmptyLogo.png';
import moment from 'moment';
import MenuApplications from '../Menu';
import { withTranslation } from 'react-i18next';

const { Text } = Typography;

export class index extends Component {
  constructor(props) {
    super(props)
  
    this.state = {
      params: {
        page: 1,
        perpage: 10,
        phaseId: 16,
        jobStatus: 'ACTIVE'
      },
      activeKey: "Departure",
      visibleDetail: false,
      isReschedule: false,
      isReject: false,
      submitLoading: false,
    }
  }
  
  componentDidMount() {
    const { params } = this.state
    const { actionMenuApplications, actionListApplications } = this.props

    return (actionMenuApplications(), actionListApplications(params))
  }

  handlePagination = (pageNumber) => {
    const { params: { perpage, phaseId, jobStatus } } = this.state
    const params = {
      page: pageNumber,
      perpage: perpage,
      phaseId: phaseId,
      jobStatus: jobStatus
    }
    this.setState({ params })
    window.scrollTo(0, 0);
    const { actionListApplications } = this.props
    return actionListApplications(params)
  }

  showModalDetail = (departureId) => {
    const { actionDetailDeparture } = this.props

    const params = {
      jobDepartureId: departureId
    }
    this.setState({
      visibleDetail: true
    })

    return actionDetailDeparture(params)
  }

  handleCancel = () => {
    this.setState({
      visibleDetail: false
    })
  }

  render() {
    const { activeKey, visibleDetail } = this.state
    const { t, getMenuApplications, getListApplications, getDetailDeparture } = this.props

    if(process.env.REACT_APP_ENV === "production"){
      ReactGA.pageview(`${window.location.pathname}${window.location.search}`, [], 'Jobshub - Applications - Departure');
    }

    const initialProps = {
      activeKey: activeKey
    }

    return (
      <React.Fragment>
        <Helmet>
          <title>Jobshub - Applications - Departure</title>
        </Helmet>
        <Row className="padding-16">
          <Col className="width-100" md={{ span: 20, offset: 2 }}>
            <Row className="mb-32">
              <Col>
                <Text className="dark-color fs-20">{t('application.applications')}</Text>
              </Col>
            </Row>
            <Row gutter={32}>
              <Col xs={24} lg={4}>
                {
                  getMenuApplications.loading ?
                    <Skeleton active />
                  :
                    <MenuApplications {...this.props} {...initialProps} />
                }
              </Col>
              <Col xs={24} lg={20}>
                <Row className="width-100 mb-8" gutter={8}>
                  <Col span={24}>
                    {
                      getListApplications.data ?
                        <Text className="dark-color fs-13">{`${t('application.assessment.showing')} ${getListApplications?.meta?.total === 0 ? getListApplications?.meta?.total : (getListApplications?.meta?.page*getListApplications?.meta?.perpage)-(getListApplications?.meta?.perpage-1)}-${getListApplications?.meta?.page === getListApplications?.meta?.pages || getListApplications?.meta?.total === 0 ? getListApplications?.meta?.total : getListApplications?.meta?.page*getListApplications?.meta?.perpage} of ${getListApplications?.meta?.total} ${t('application.assessment.job')}`}</Text>
                      :
                        <Skeleton.Input active />
                    }
                  </Col>
                </Row>
                <Row className="mb-16">
                  <Col span={24}>
                    {
                      getListApplications.loading ?
                        <Card className="border-radius-3 box-shadow mb-6">
                          <Skeleton active avatar />
                        </Card>
                      :
                        getListApplications?.data?.length > 0 ?
                          getListApplications?.data?.map((item, i) => 
                            <Card key={i} className="border-radius-3 box-shadow mb-6">
                              <Row className="width-100" gutter={16} style={{ marginBottom: -10 }}>
                                <Col className="col-img-job" xs={24} sm={4} md={4}>
                                  {/* <Link to={`/candidate/company/${item.companyId}/${item.companyType}`}> */}
                                  <Link to={`/candidate/job/detail/${item.slug}`}>
                                    <Image
                                      src={item.companyLogoUrl ? item.companyLogoUrl : EmptyLogo}
                                      preview={false}
                                      width={'100%'}
                                      height={80}
                                      style={{ objectFit: 'contain' }}
                                    />
                                  </Link>
                                </Col>
                                <Col xs={24} sm={13} md={12}>
                                  <Space direction="vertical" size={0}>
                                    <Link to={`/candidate/job/detail/${item.slug}`}>
                                      <Text className="info-color fs-17">{item.title}</Text>
                                    </Link>
                                    <Text className="fs-13 dark-color">{item.companyName} {item.isVerified ? <SafetyOutlined className="primary-color" /> : null}</Text>
                                    <Text className="fs-13 dark-color"><EnvironmentOutlined /> {item.jobDestinationParentId ? `${item.jobDestinationName}, ${item.jobDestinationParentName}` : item.jobDestinationName}</Text>
                                  </Space>
                                </Col>
                                <Col xs={24} sm={7} md={8} className="application-date">
                                  <Space direction="vertical" size={8} className="application-date">
                                    <Text className="application-date fs-13 dark-color">{`${t('application.assessment.applied')} ${item.applyDate}`}</Text>
                                    <Button className="btn-info application-date mt-8 fs-12" onClick={() => this.showModalDetail(item.departureId)}>
                                      Details
                                    </Button>
                                    <Modal 
                                      title={
                                        getDetailDeparture.loading ?
                                          <Skeleton paragraph={{ rows: 1 }} active />
                                        :
                                          <Space className="text-align-center width-100" direction="vertical">
                                            <Text className="fs-20 primary-color">Departure Detail</Text>
                                            <Text className="fs-15 dark-color">{`${getDetailDeparture?.data?.jobPositionName} - ${getDetailDeparture?.data?.companyName}`}</Text>
                                          </Space>
                                      } 
                                      width={800}
                                      visible={visibleDetail} 
                                      onCancel={this.handleCancel}
                                      footer={false}
                                    >
                                      {
                                        getDetailDeparture.loading ?
                                          <Skeleton active />
                                        :
                                          <React.Fragment>
                                            <Space className="width-100" direction="vertical">
                                              <Text>Good news! You have accepted the job offer, and you are ready to go.</Text>
                                              <Text>We have set the date for your join date and provided the details for your departure: date, time, and location.</Text>
                                              <Row gutter={16}>
                                                <Col xs={10} lg={5}>
                                                  {/* <Text>{t('application.assessment.date')}</Text> */}
                                                  <Text>Join Date</Text>
                                                </Col>
                                                <Col xs={14} lg={19}>
                                                  <Space align="start" style={{ textAlign: 'justify' }}>
                                                    <Text>:</Text>
                                                    <Text strong>{moment(getDetailDeparture?.data?.joinDate, 'DD/MM/YYYY').format('DD MMMM YYYY')}</Text>
                                                  </Space>
                                                </Col>
                                                <Col xs={10} lg={5}>
                                                  {/* <Text>{t('application.assessment.time')}</Text> */}
                                                  <Text>Departure Date/Time</Text>
                                                </Col>
                                                <Col xs={14} lg={19}>
                                                  <Space align="start" style={{ textAlign: 'justify' }}>
                                                    <Text>:</Text>
                                                    <Text strong>{getDetailDeparture?.data?.departureDate && getDetailDeparture?.data?.departureTime ? `${moment(getDetailDeparture?.data?.departureDate, 'DD/MM/YYYY').format('DD MMMM YYYY')} ${moment(getDetailDeparture?.data?.departureTime, 'hh:mm:ss').format('HH:mm')}` : '-'}</Text>
                                                  </Space>
                                                </Col>
                                                <Col xs={10} lg={5}>
                                                  {/* <Text>{t('application.assessment.location')}</Text> */}
                                                  <Text>Departure Location</Text>
                                                </Col>
                                                <Col xs={14} lg={19}>
                                                  <Space align="start" style={{ textAlign: 'justify', marginBottom: -12 }}>
                                                    <Text>:</Text>
                                                    <div className="font-weight-bold" dangerouslySetInnerHTML={{ __html: getDetailDeparture?.data?.location ? getDetailDeparture?.data?.location : '-' }}></div>
                                                  </Space>
                                                </Col>
                                              </Row>
                                              <Space>
                                                <Text>Notes:</Text>
                                                <div className="font-weight-bold" dangerouslySetInnerHTML={{ __html: getDetailDeparture?.data?.candidateNote ? getDetailDeparture?.data?.candidateNote : '-' }} style={getDetailDeparture?.data?.candidateNote ? { marginBottom: -14 } : null}></div>
                                              </Space>
                                              <Text>If you have any questions or need more information, feel free to contact us. We are here to help.</Text>
                                              <Text>Thank you for your cooperation and excitement. We can't wait to have you onboard soon!</Text>
                                              <Space className="float-right mt-32">
                                                <Button className="fs-12 border-radius-3" type="primary" onClick={this.handleCancel}>{t('application.assessment.okay')}</Button>
                                              </Space>
                                            </Space>
                                          </React.Fragment>
                                        }
                                    </Modal>
                                  </Space>
                                </Col>
                              </Row>
                          </Card>
                      )
                        :
                          <Card className="border-radius-3 box-shadow mb-6">
                            <Empty />
                          </Card>
                    }
                  </Col>
                </Row>
                <Row>
                  <Col className="text-align-center" span={24}>
                    <Pagination onChange={this.handlePagination} current={getListApplications?.meta?.page} pageSize={getListApplications?.meta?.perpage || 10} total={getListApplications?.meta?.total} />
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
      </React.Fragment>
    )
  }
  componentWillUnmount(){
    const { unmountMenuApplications, unmountListApplications, unmountDeparture } = this.props
    return (unmountMenuApplications(), unmountListApplications(), unmountDeparture())
  }
}

const mapStateToProps = (state) => ({
  getMenuApplications: state.menuApplicationsReducer,
  getListApplications: state.listApplicationsReducer,
  getDetailDeparture: state.departureReducer
})

const mapDispatchToProps = {
  actionMenuApplications: menuApplications,
  unmountMenuApplications: unmountMenuApplications,
  actionListApplications: listApplications,
  unmountListApplications: unmountListApplications,
  actionDetailDeparture: detailDeparture,
  unmountDeparture: unmountDeparture,
  actionListNotification: listNotification,
  actionCountNotification: countNotification
}

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(index))